import React from 'react';
import { Modal, Button } from 'components';
import { METRICS_GLOSSARY } from './metrics-glossary';

interface Props {
	visible: boolean;
	section: string;        // 'users' | 'patrimony' | 'plans' | 'chat' | 'activity'
	sectionLabel: string;   // ej: "Usuarios"
	onClose: () => void;
}

const ModalGlossary = (props: Props) => {
	const { visible, section, sectionLabel, onClose } = props;
	const definitions = METRICS_GLOSSARY[section] || [];

	return (
		<Modal
			className="modal-glossary"
			visible={ visible }
			title={ `Glosario · ${ sectionLabel }` }
			onClose={ onClose }
		>
			<div id="modal-glossary">
				<p className="mg-intro">
					Definición de cada métrica de la sección <strong>{ sectionLabel }</strong>.
				</p>

				<div className="mg-list">
					{
						definitions.length > 0 ? (
							definitions.map((d) => (
								<div className="mg-item" key={ d.key }>
									<h4>{ d.title }</h4>
									<p className="mg-desc">{ d.description }</p>
									<p className="mg-details">{ d.details }</p>
								</div>
							))
						) : (
							<p className="mg-empty">No hay definiciones para esta sección.</p>
						)
					}
				</div>

				<div className="mg-footer">
					<Button className="btn-close-mg" color="secondary" onClick={ onClose }>
						Cerrar
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default ModalGlossary;
